export const facebook = "https://www.facebook.com";
export const linkedin = "https://www.linkedin.com/company/aquariusconsultants/";
export const twitter = "https://www.twitter.com";
export const youtube = "https://www.youtube.com";
export const instagram = "https://www.instagram.com";